import BlogPage from '../components/pages/BlogPage.jsx';

export default BlogPage;

